<div class="d-flex align-items-center" style="border: 1px solid #c9c9c9; padding: 9px 12px;">
  <button
    data-automation-id="dialog-close-button"
    type="button"
    matPrefix
    mat-icon-button
    (click)="clear()"
    *ngIf="!disabled && !readonly && value"
    title="Clear"
  >
    <mat-icon>close</mat-icon>
  </button>
  <a
    [routerLink]="routerLink"
    target="_blank"
    *ngIf="routerLink && !disableLink"
    data-automation-id="inner-lookup_202126135937"
    class="link--open-new"
  >
    {{ formattedValue }}
    <mat-icon>open_in_new</mat-icon>
    <span class="visually-hidden">(Link opens in a new window)</span>
  </a>
  <span
    class="py-1"
    *ngIf="!routerLink || disableLink"
    data-automation-id="inner-lookup_202126135943"
  >
    {{ formattedValue }}
  </span>
  <span class="flex-fill"></span>
  <button
    class="mat-simple-button"
    color="primary"
    data-automation-id="inner-lookup_202126135948"
    type="button"
    matSuffix
    mat-button
    (click)="openLookupClick()"
    *ngIf="!multiTypeLookup && !disabled && !readonly"
    aria-label="Lookup"
  >
    <mat-icon>search</mat-icon>
    {{ placeholder }}
  </button>
  <button
    #lookupMenuButton
    type="button"
    class="mat-simple-button"
    color="primary"
    data-automation-id="inner-lookup_202126140004"
    matSuffix
    mat-button
    [matMenuTriggerFor]="menu"
    *ngIf="multiTypeLookup && !disabled && !readonly"
    aria-label="Lookup"
  >
    <span class="d-flex align-items-center">
      <mat-icon>search</mat-icon>
      Lookup
    </span>
    <mat-icon class="rotate">expand_more</mat-icon>
  </button>
  <mat-menu class="mat-simple-menu" #menu="matMenu">
    <button
      data-automation-id="inner-lookup_202126140017"
      mat-menu-item
      *ngFor="let type of lookupTypes"
      (click)="openLookupWithType(type)"
      aria-label="Lookup"
    >
      {{ type }}
    </button>
  </mat-menu>
</div>
